export const groupSpecificFieldsByProduct = (arr) => {
  return Object.fromEntries(
    arr.map((fields) => [fields.id, fields.dynamic_fields_sales_products])
  )
}
